import { MessagingTemplatesState } from "@idw-types/state/messaging-templates-state";
import { MessagingTemplatesActionTypes, MessagingTemplatesActions } from "../actions/messaging-templates-actions";

export const initialMessagingTemplatesState: MessagingTemplatesState = {
    messagingTemplates: {
        isLoading: false,
        messagingTemplates: null
    }
};

export const messagingTemplatesReducer = (
    state: MessagingTemplatesState = initialMessagingTemplatesState,
    action: MessagingTemplatesActions
): MessagingTemplatesState => {
    switch (action.type) {
        // Messaging Templates
        case MessagingTemplatesActionTypes.SET_MESSAGING_TEMPLATES_LOADING:
            return {
                ...state,
                messagingTemplates: {
                    ...(action.payload.isLoading
                        ? { ...initialMessagingTemplatesState.messagingTemplates }
                        : { ...state.messagingTemplates }),
                    isLoading: action.payload.isLoading
                }
            };
        case MessagingTemplatesActionTypes.SET_MESSAGING_TEMPLATES:
            return {
                ...state,
                messagingTemplates: {
                    ...state.messagingTemplates,
                    messagingTemplates: action.payload.axnMessagingTemplates,
                    isLoading: false
                }
            };
        case MessagingTemplatesActionTypes.ADD_MESSAGING_TEMPLATE:
            return {
                ...state,
                messagingTemplates: {
                    ...state.messagingTemplates,
                    messagingTemplates: state.messagingTemplates.messagingTemplates
                        ? [...state.messagingTemplates.messagingTemplates, action.payload.messagingTemplate]
                        : [action.payload.messagingTemplate]
                }
            };
        default:
            return state;
    }
};